import { setup } from "web/entrypoints/common/setup";
import "./css-pdp";
import components from "./react-pdp";

setup(components);
